import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-share",
  imports: [NgClass],
  templateUrl: "./icon-share.component.html",
  styleUrl: "./icon-share.component.scss",
})
export class IconShareComponent {
  @Input() isSelected: boolean = false;
  @Input() selected: boolean = false;
  @Input() shared: boolean = false;
}
